import { InspectionFilters } from '@shared/models/inspection-filters';

export const INSPECTION_PAGE_SIZE_OPTIONS = [50, 100, 200];

export const INSPECTION_FLOORPLAN_MARKER_POPUP_SIZE = {
  width: 350,
  height: 170
};

export const DEFAULT_INSPECTION_FILTERS: InspectionFilters = {
  inspectionIds: [],
  statuses: [],
  accountIds: [],
  inspectionAttributes: {}
};
